/**
 * ClassesGrid - Grid layout for displaying classes in Dashboard3 style
 *
 * @example
 * ```tsx
 * <ClassesGrid data={classes} />
 * ```
 */

"use client";

import { SimpleGrid } from "@chakra-ui/react";
import type { GetClassResponse } from "@/openapi/generated";
import { ClassCard } from "./ClassCard";

export interface ClassesGridProps {
  data: GetClassResponse[];
}

export const ClassesGrid = ({ data }: ClassesGridProps) => {
  return (
    <SimpleGrid
      columns={{ base: 1, sm: 2, lg: 3, xl: 4 }}
      spacing={{ base: 4, md: 6 }}
      mt={6}
    >
      {data.map((classItem) => (
        <ClassCard key={String(classItem.classId)} class={classItem} />
      ))}
    </SimpleGrid>
  );
};

